export default __webpack_public_path__ + "static/media/Instagram.c17c7f8d.png";